const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadssource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 279.269,
    y1: 256,
    x2: 358.792,
    y2: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 279.269,193.151 300.223,193.151 300.223,72.256 358.792,72.256 \t\t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 358.792,439.744 300.223,439.744 300.223,318.849 279.269,318.849 \t\t\t"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M441.361,72.256L441.361,72.256c-14.957,0-27.083-12.125-27.083-27.083V34.583c0-14.957,12.125-27.083,27.083-27.083h0 c14.957,0,27.083,12.125,27.083,27.083v10.591C468.444,60.131,456.318,72.256,441.361,72.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M418.598,59.838c-0.649,0.322-1.293,0.653-1.922,1.009c-12.013,6.795-20.122,19.687-20.122,34.474v39.385 c0,5.882,4.769,10.651,10.651,10.651h68.312c5.883,0,10.651-4.769,10.651-10.651V115.05"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M485.054,86.05c-2.647-11.02-9.884-20.253-19.598-25.53c-0.438-0.238-0.889-0.453-1.336-0.674"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M441.361,251.827L441.361,251.827c-14.957,0-27.083-12.125-27.083-27.083v-10.591c0-14.957,12.125-27.083,27.083-27.083h0 c14.957,0,27.083,12.125,27.083,27.083v10.591C468.444,239.702,456.318,251.827,441.361,251.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M418.598,239.41c-0.65,0.322-1.293,0.653-1.922,1.009c-12.013,6.794-20.122,19.687-20.122,34.474v39.385 c0,5.883,4.769,10.651,10.651,10.651h68.312c5.883,0,10.651-4.769,10.651-10.651v-39.385c0-15.027-8.375-28.099-20.713-34.801 c-0.438-0.237-0.889-0.453-1.336-0.674"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M441.361,431.398L441.361,431.398c-14.957,0-27.083-12.125-27.083-27.083v-10.591c0-14.957,12.125-27.083,27.083-27.083h0 c14.957,0,27.083,12.125,27.083,27.083v10.591C468.444,419.273,456.318,431.398,441.361,431.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M450.758,504.5h24.759c5.883,0,10.651-4.769,10.651-10.651v-39.385c0-15.028-8.375-28.099-20.713-34.801 c-0.438-0.238-0.889-0.453-1.336-0.674"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M418.598,418.981c-0.649,0.322-1.293,0.653-1.922,1.009c-12.013,6.794-20.122,19.687-20.122,34.474v39.385 c0,5.882,4.769,10.651,10.651,10.651h14.553"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.498,
    y: 161.258,
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 39.725,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.498,
    y: 294.742,
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 39.725,
    height: 56
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M85.296,168.075C50.476,182.095,25.831,216.222,25.831,256c0,52.24,42.501,94.741,94.742,94.741h76.925v-56h-76.925 c-21.362,0-38.742-17.38-38.742-38.742s17.38-38.741,38.742-38.741h76.925v-56h-76.925c-2.163,0-4.307,0.08-6.434,0.223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadssource);
export default __webpack_public_path__ + "static/media/leads source.52553435a77eeaabf26d3443d572ec82.svg";
export { ForwardRef as ReactComponent };